import * as MetaPixel from './pixel'
import { trackGoogleAdsEvent, trackGoogleAdsPageView } from './googleAds'

export const createEventId = MetaPixel.createEventId

// Keep the same interaction points and event IDs for both ad providers.
// A failure in either provider must not interrupt the other or navigation.
export function trackEvent(name, params = {}, { eventId } = {}) {
  const resolvedEventId = eventId || createEventId(name)
  try { MetaPixel.trackEvent(name, params, { eventId: resolvedEventId }) } catch {}
  try { trackGoogleAdsEvent(name, params, { eventId: resolvedEventId }) } catch {}
  return resolvedEventId
}

export function trackPageView(params = {}, { eventId } = {}) {
  const resolvedEventId = eventId || createEventId('PageView')
  try { MetaPixel.trackPageView(params, { eventId: resolvedEventId }) } catch {}
  try { trackGoogleAdsPageView(params) } catch {}
  return resolvedEventId
}
